import { ShareButton } from "./ShareButton";

/**
 * Featured Quote — a single, prominently-displayed signature quote on the
 * home page. Designed as a daily/feature card; copy can rotate over time.
 */
export const FEATURED_QUOTE = {
  text:
    "Each day, I am reminded that Life is married to Uncertainty until death do them part. Until then, we who live must continue to face their children.",
  author: "Minister JEB",
  source: "Mr. B Quotes",
};

export function FeaturedQuote() {
  const shareText = `"${FEATURED_QUOTE.text}" — ${FEATURED_QUOTE.author}\n\nFrom Mr. B Quotes · mrbquotes.com`;

  return (
    <section
      aria-labelledby="featured-quote-heading"
      className="border-t border-border/60"
    >
      <div className="mx-auto max-w-5xl px-4 py-16 sm:py-24">
        <div className="flex flex-col items-center text-center">
          <div className="inline-flex items-center gap-2 rounded-full border border-gold/30 bg-gold/5 px-3 py-1 text-[10px] uppercase tracking-[0.3em] text-gold">
            <span className="h-1.5 w-1.5 rounded-full bg-gold animate-pulse" />
            Featured Quote
          </div>
          <h2 id="featured-quote-heading" className="sr-only">
            Featured quote from Mr. B Quotes
          </h2>

          <figure className="relative mt-8 max-w-3xl">
            <span
              aria-hidden
              className="absolute -top-10 -left-3 sm:-left-8 font-display text-[8rem] sm:text-[10rem] leading-none text-gold/20 select-none"
            >
              &ldquo;
            </span>
            <blockquote className="relative font-display text-2xl sm:text-3xl md:text-4xl leading-snug text-foreground">
              {FEATURED_QUOTE.text}
            </blockquote>
            <figcaption className="mt-6 text-sm uppercase tracking-[0.3em] text-gold">
              — {FEATURED_QUOTE.author}
            </figcaption>
          </figure>

          <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
            <ShareButton text={shareText} title="Featured Quote — Mr. B Quotes" label="Share this quote" />
            <a
              href="https://www.youtube.com/@ministerjeb"
              target="_blank"
              rel="noopener noreferrer"
              className="rounded-full border border-border px-5 py-3 text-sm hover:border-gold hover:text-gold transition"
            >
              More from Minister JEB →
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
